import type { RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { App } from 'antd';
import React from 'react';
import { AvatarDropdown, Footer } from '@/components';
import ErrorBoundary from '@/components/ErrorBoundary';
import { getUserCurrentUser } from '@/services/api/user';
import defaultSettings from '../config/defaultSettings';
import { requestConfig } from './requestConfig';
import '@ant-design/v5-patch-for-react-19';
const loginPath = '/user/login';

/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState(): Promise<InitialState> {
  const fetchUserInfo = async (): Promise<API.CurrentUserInfo | undefined> => {
    try {
      const res = await getUserCurrentUser();
      if (res.code === 200 && res.data) {
        return res.data;
      }
      return undefined;
    } catch {
      history.push(loginPath);
      return undefined;
    }
  };

  let currentUser: API.CurrentUserInfo | undefined;
  if (history.location.pathname !== loginPath) {
    currentUser = await fetchUserInfo();
  }

  return { currentUser, fetchUserInfo };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  return {
    // 用户头像渲染
    avatarProps: {
      render: () => <AvatarDropdown />,
    },
    waterMarkProps: {
      content: initialState?.currentUser?.name,
    },
    footerRender: () => <Footer />,
    menuHeaderRender: undefined,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    ...defaultSettings,
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = requestConfig;

/**
 * 包裹整个应用，提供 App 组件上下文（支持 message、notification、modal 等静态方法使用动态主题）
 */
export function rootContainer(container: React.ReactNode) {
  return (
    <App>
      <ErrorBoundary>{container}</ErrorBoundary>
    </App>
  );
}
